import Avatar from "@mui/material/Avatar";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Avatar key={component.id} />;
}

export default Component;
